// import '../css/game.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './game/App.jsx';

if (import.meta.env?.VITE_SENTRY_REACT_DSN != undefined && import.meta.env?.VITE_APP_ENV != 'local') {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_REACT_DSN,
        sendDefaultPii: true,
        environment: import.meta.env.VITE_APP_ENV ?? 'staging',
    });
}

const domNode = document.getElementById('ReactGame');
const root = createRoot(domNode);
root.render(<App />);
